import React from 'react'

import './_content-page.scss'
import { pageProps } from 'types'
import { Layout } from '../../components/layout/layout'
import { ComponentList } from '../../components/blocks/component-list/component-list'
import { Header } from 'components/layout/header'

interface ContentPageProps extends pageProps {}

export const ContentPage = ({ layout, header, blocks }: ContentPageProps) => (
  <Layout {...layout} theme={layout.theme ?? {color: 'green', type: 'solid'}}  className='content-page'>
    {header && <Header {...{ ...header, data: { ...header.data, background: 'green' } }} />}
    {blocks && <ComponentList blocks={blocks} />}
  </Layout>
)
